module.exports = __webpack_public_path__ + "media/audio31.fcef3c88.mp3";